export default __webpack_public_path__ + "static/media/logo10.8cfd8669.svg";